/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {getIconColor} from './helpers';

import './icon-only-button.module.css';

export type ButtonVariant = 'default' | 'purple' | 'orange';

type Props = {
    icon: React.ComponentType<*>,
    onClick: (e: SyntheticEvent<*>) => void,
    // Normal: 24px, Large: 32px
    size?: 'normal' | 'large',
    tooltipText?: string,
    isDisabled?: boolean,
    isActive?: boolean,
    hasBorder?: boolean,
    // Variants only affect the active state of the buttons
    variant?: ButtonVariant,
    getButtonRef?: any,
    id?: string,
};

export const IconOnlyButton = (props: Props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    const {
        icon: Icon,
        onClick,
        size = 'normal',
        tooltipText,
        isDisabled = false,
        isActive = false,
        hasBorder,
        variant = 'default',
        getButtonRef,
    } = props;

    const buttonStyles = classnames('icon-only-button', {
        'icon-only-button--size-24': size === 'normal',
        'icon-only-button--size-32': size === 'large',
        'icon-only-button--active': isActive,
        'icon-only-button--disabled': isDisabled,
        'icon-only-button--border': hasBorder,
        'icon-only-button--purple': variant === 'purple',
        'icon-only-button--orange': variant === 'orange',
    });

    const iconColor = getIconColor(isDisabled, isActive, variant);

    const handleClick = (e: SyntheticEvent<*>) => {
        if (isDisabled) {
            return;
        }
        onClick(e);
    };

    return (
        <button
            id={props.id}
            type='button'
            styleName={buttonStyles}
            onClick={handleClick}
            ref={getButtonRef}
            data-tip={tooltipText}
        >
            <Icon
                wrapWithDiv={false}
                size={20}
                alignCenter={true}
                color={iconColor}
                fill={iconColor}
            />
        </button>
    );
};
